import React, { useState } from 'react';
import { Box, Card, CardHeader, CardContent, Typography } from '@mui/material';
import EmergencyTable from './components/EmergencyTable';
import { useTranslation } from 'react-i18next';

function EmergencyPanel() {
  const [selectedLocation, setSelectedLocation] = useState("");
  const { t } = useTranslation();

  return (
    <Box sx={{ padding: '10px', width: '100%' }}>
      {/* Table Container */}
      <Box sx={{ width: '100%', marginTop: '20px' }}>
        <Card elevation={3} sx={{ width: "100%" }}>
          <CardHeader
            title={
              <Typography
                variant="h5"
                component="div"
                sx={{ color: "primary.main", fontWeight: "bold" }}
              >
                {t("Main.Emergency.EmergencyPatients")}
              </Typography>
            }
          />
          <CardContent>
            <Box sx={{ width: "100%" }}>
              <EmergencyTable
                selectedLocation={selectedLocation}
                setSelectedLocation={setSelectedLocation}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default EmergencyPanel;
